import { EventDispatcher, Listener } from './EventDispatcher'
import { Event } from 'three'

export enum EVENTS_GAME {
  GAME_BOOT = 'GAME:BOOT',
  BATTLE_BEGINS = 'BATTLE:BEGIN',
  MENU_DISMISS = 'MENU:DISMISS',
  LOADING_START = 'LOADING_START',
  LOADING_COMPLETE = 'LOADING_COMPLETE',
  LOADING_PROGRESS = 'LOADING_PROGRESS',
  LOADING_ERROR = 'LOADING_ERROR',
}
export enum EVENTS_SOUNDS {
  PLAY = 'SOUND:PLAY',
  PAUSE = 'SOUND:PAUSE',
  STOP = 'SOUND:STOP',
  VOLUME = 'SOUND:VOLUME',
  FADEIN = 'SOUND:FADEIN',
  FADEOUT = 'SOUND:FADEOUT',
}
export enum EVENTS_INPUT {
  POINTER_UP = 'POINTER_UP',
}
export enum EVENTS_OBJECTS {
  SELECT = 'GAME:OBJECT:SELECT',
  DESELECT = 'GAME:OBJECT:DESELECT',
  MOVE_START = 'GAME:OBJECT:START_MOVING',
  MOVE_END = 'GAME:OBJECT:END_MOVING',
  ATTACK_END = 'GAME:OBJECT:ATTACK_END',
  CAST_SPELL = 'GAME:OBJECT:SPELL:CAST',
  MAGIC_IMPACT = 'GAME:OBJECT:SPELL:MAGIC_IMPACT',
}
export enum EVENTS_TICK {
  TICK = 'TICK',
  TICK_HALF = 'TICK_HALF',
  TICK_QUARTER = 'TICK_QUARTER',
}
const eventManager = new EventDispatcher()
export default eventManager

export const addEventListener = (type: string, listener: Listener) => {
  eventManager.addEventListener(type, listener)
  return () => eventManager.removeEventListener(type, listener)
}

export const removeEventListener = eventManager.removeEventListener
// export { default as useEvents } from '../../hooks/useEvents'

export const once = (type: string, listener: Listener) => {
  const onceListener = (event: Event) => {
    listener(event)
    eventManager.removeEventListener(type, onceListener)
  }
  eventManager.addEventListener(type, onceListener)
}

export const awaitFor = (type: string) =>
  new Promise(res => {
    once(type, res)
  })

export const dispatch = (type: string, payload: unknown) => {
  // console.log('GAME EVT: ', type);
  eventManager.dispatchEvent({ type, payload })
}
